module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification"
  }, [_c('p', {
    staticClass: "total-title"
  }, [_c('span', [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-dongtai"
    }
  })])]), _vm._v(_vm._s(_vm.$t('dynamic')) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "main-info"
  }, [(_vm.messages.length === 0) ? _c('p', {
    staticClass: "text-center",
    attrs: {
      "id": "no-messages"
    }
  }, [_vm._v(_vm._s(_vm.$t('noMessage')))]) : _vm._l((_vm.messages), function(item) {
    return _c('div', {
      class: [item.show ? 'show-content' : 'not-show-content', 'a-dynamic'],
      on: {
        "click": function($event) {
          return _vm.toggle(item)
        }
      }
    }, [_c('p', {
      staticClass: "time-and-title"
    }, [_c('span', {
      staticClass: "time pull-left"
    }, [_vm._v(_vm._s(_vm._f("createFormatTime")(item.created_at, item.created_at)) + " ")]), _vm._v(" "), _c('br', {
      staticClass: "show-phone"
    }), _vm._v(" "), _c('span', {
      class: [{
        'not-complete': item.show
      }, 'little-title']
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('p', {
      staticClass: "content"
    }, [_vm._v(_vm._s(item.content))])])
  }), _vm._v(" "), (_vm.loadMore.show) ? _c('show-more', {
    attrs: {
      "showSpinner": _vm.loadMore.showSpinner
    },
    nativeOn: {
      "click": function($event) {
        return _vm.loadNotifications($event)
      }
    }
  }) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4562f729!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/notification/Notification.vue
// module id = 1312
// module chunks = 1